export const REFRESH_INTERVAL_MS = 5 * 60 * 1000 // 5 minutes in milliseconds
